import { useQuery } from '@tanstack/react-query';
import { getCloudflareStatus } from '../../../services/bot-sources/CloudflareIntegrationService';
import { CloudflareStatusResponse } from '../../../types/bot-sources/CloudflareStatusResponse';
import { CLOUDFLARE_STATUS } from '../../query/bot-sources/keys';

/**
 * Treat "connected but no `lastPollAt`" as backfill-in-progress and refetch
 * every 20 s. Aligns with `useGetFastlyStatus` and matches the behavior
 * documented in `pages/bots-activity/CLAUDE.md`.
 */
const isBackfillInProgress = (data: CloudflareStatusResponse | undefined): boolean =>
  !!data?.isConnected && !data?.lastPollAt;

export const useGetCloudflareStatus = (projectId: number | null) => {
  const queryEnabled = !!projectId;

  const { data, isLoading, refetch, isError } = useQuery<CloudflareStatusResponse>({
    queryKey: [CLOUDFLARE_STATUS, projectId],
    queryFn: () => getCloudflareStatus(projectId!),
    staleTime: 1000 * 60,
    gcTime: 1000 * 60 * 10,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: queryEnabled,
    refetchInterval: (query) =>
      isBackfillInProgress(query.state.data as CloudflareStatusResponse | undefined)
        ? 20_000
        : false,
  });

  return {
    data,
    isLoading: queryEnabled ? isLoading : false,
    isError,
    refetch,
  };
};
